import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Card, StateBadge, ReadMore, fmt, btnPrimary, Empty } from "@/components/portal/PortalUI";
import { Upload, ShieldCheck } from "lucide-react";

export const StudentUploads = ({ requests, reload }) => {
  const upload = async (r, file) => {
    const fd = new FormData(); fd.append("file", file);
    try { await api.post(`/student/requests/${r.request_id}/upload`, fd); toast.success("Uploaded securely — pending review"); reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card title="Requested Document Uploads" testid="student-uploads">
      <p className="flex items-center gap-2 text-xs text-dark-text/60 mb-4"><ShieldCheck size={14} className="text-magenta" /> Files are stored securely and visible only to authorized AAWTA staff. Never email sensitive documents.</p>
      {requests.length === 0 ? <Empty>No document uploads have been requested.</Empty> : (
        <div className="space-y-3">
          {requests.map((r) => {
            const last = r.submissions[r.submissions.length - 1];
            const canUpload = !["Accepted", "Pending Review"].includes(r.status);
            return (
              <div key={r.request_id} className="border border-navy/10 rounded-lg p-4" data-testid={`request-${r.request_id}`}>
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <h4 className="font-display font-bold text-navy">{r.title} <span className="text-xs font-normal text-dark-text/50">· {r.doc_type}{r.required ? " · Required" : " · Optional"}</span></h4>
                    <ReadMore summary={r.instructions} description={r.description} testid={`request-readmore-${r.request_id}`} />
                    <p className="text-xs text-dark-text/50 mt-2">Due {fmt(r.due_date)} · Allowed: {r.allowed_types.join(", ")}</p>
                    {last && <p className="text-xs mt-1">Last upload: <strong>{last.filename}</strong> ({fmt(last.uploaded_at)})</p>}
                    {last?.reason && <p className="text-xs mt-1 text-red-700 bg-red-50 rounded px-2 py-1 inline-block" data-testid={`request-reason-${r.request_id}`}>Reason: {last.reason}</p>}
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="text-xs font-bold text-navy" data-testid={`request-status-${r.request_id}`}>{r.status}</span>
                    <StateBadge state={r.status === "Accepted" ? "Completed" : r.state} />
                  </div>
                </div>
                {canUpload && (
                  <label className={`${btnPrimary} mt-3 cursor-pointer`} data-testid={`request-upload-${r.request_id}`}>
                    <Upload size={15} /> {r.submissions.length ? "Upload Replacement" : "Upload File"}
                    <input type="file" className="hidden" accept={r.allowed_types.map((t) => `.${t}`).join(",")} onChange={(e) => e.target.files[0] && upload(r, e.target.files[0])} />
                  </label>
                )}
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
};
